export default __webpack_public_path__ + "static/media/HEN.caea45d3.wav";